import { render, staticRenderFns } from "./ProductSliders.vue?vue&type=template&id=7c5d0068&scoped=true&"
import script from "./ProductSliders.vue?vue&type=script&lang=js&"
export * from "./ProductSliders.vue?vue&type=script&lang=js&"
import style0 from "./ProductSliders.vue?vue&type=style&index=0&id=7c5d0068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5d0068",
  null
  
)

export default component.exports